var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7565,
    cy: 27.0841,
    r: 26.6979,
    fill: "#EEEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_932_1776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0743 25.3928H34.7209V19.9851C34.7209 15.5068 31.0906 11.8765 26.6123 11.8765C22.1339 11.8765 18.5036 15.5068 18.5036 19.9851V25.3928H17.1503C16.4068 25.3928 15.7969 25.9969 15.7969 26.7462V40.2625C15.7969 41.0118 16.401 41.6159 17.1503 41.6159H36.0743C36.8178 41.6159 37.4277 41.0118 37.4277 40.2625V26.7462C37.4277 25.9969 36.8178 25.3928 36.0743 25.3928ZM32.02 25.3928H21.2046V19.9851C21.2046 16.9995 23.6267 14.5774 26.6123 14.5774C29.5978 14.5774 32.02 16.9995 32.02 19.9851V25.3928Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_1776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7394,
    height: 29.7394,
    fill: "white",
    transform: "translate(11.7734 11.8765)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLock);
export default __webpack_public_path__ + "static/media/fileLock.a817bf25921de44ad347bce019ab170a.svg";
export { ForwardRef as ReactComponent };